import { render, staticRenderFns } from "./PublicidadesFijas.vue?vue&type=template&id=c9e5ab46&scoped=true"
import script from "./PublicidadesFijas.vue?vue&type=script&lang=js"
export * from "./PublicidadesFijas.vue?vue&type=script&lang=js"
import style0 from "./PublicidadesFijas.vue?vue&type=style&index=0&id=c9e5ab46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e5ab46",
  null
  
)

export default component.exports